<template>
  <v-card>
    <v-container>
      <v-row>
        <v-spacer></v-spacer>
        <v-col cols="4">
          <v-menu
            ref="menuFrom"
            v-model="fromMenu"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            max-width="290px"
            min-width="290px"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                dense
                v-model="data.from"
                label="Od"
                readonly
                v-bind="attrs"
                v-on="on"
                outlined
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="data.from"
              no-title
              scrollable
              locale="cz-cs"
            >
            </v-date-picker>
          </v-menu>
        </v-col>
        <v-spacer></v-spacer>
      </v-row>
      <v-row>
        <v-spacer></v-spacer>
        <v-col cols="4">
          <v-menu
            ref="menuTo"
            v-model="toMenu"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            max-width="290px"
            min-width="290px"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                dense
                v-model="data.to"
                outlined
                label="Do"
                readonly
                v-bind="attrs"
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="data.to"
              no-title
              scrollable
              locale="cz-cs"
            >
            </v-date-picker>
          </v-menu>
        </v-col>
        <v-spacer></v-spacer>
      </v-row>
      <v-row>
        <v-spacer></v-spacer>
        <v-col
          cols="4">
          <v-btn
            dark
            color="success"
            @click="exportInvoices"
          >Export</v-btn>
        </v-col>
        <v-spacer></v-spacer>
      </v-row>
    </v-container>
  </v-card>
</template>

<script>
import ExcelJS from 'exceljs'

export default {
  name: 'ExportInvoices',
  data () {
    return {
      invoices: [],
      fromMenu: false,
      toMenu: false,
      data: {
        from: null,
        to: null
      }
    }
  },
  methods: {
    exportInvoices () {
      this.$http({
        method: 'POST',
        url: '/admin/invoices/export',
        data: this.dateModify()
      }).then(response => {
        this.invoices = response.data
        this.exportXLS()
      })
    },
    dateModify () {
      let to = new Date(this.data.to)
      to.setDate(to.getDate() + 1)
      to = to.toISOString().split('T')[0]
      const from = this.data.from
      return { from, to }
    },
    exportXLS () {
      const workbook = new ExcelJS.Workbook()
      const sheet = workbook.addWorksheet('Export faktur')
      sheet.getCell('A1').value = 'Export faktur'
      const now = new Date()
      const nowCzDate = now.toLocaleDateString('cs-CZ', {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
      })
      const nowCzTime = now.toLocaleTimeString([], {
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit'
      })
      sheet.mergeCells('A2:C2')
      sheet.getCell('A2').value = `${nowCzDate} ${nowCzTime}`
      sheet.getRow(4).values = [
        'ID',
        'ID Transakce',
        'Datum',
        'Uživatel (Firma)',
        'Cena bez DPH',
        'Cena s DPH',
        'Celkem'
      ]
      sheet.columns = [
        { key: 'id', width: 20 },
        { key: 'transaction_id', width: 20 },
        { key: 'created_at', width: 20 },
        { key: 'user', width: 40 },
        { key: 'priceWithoutDPH', width: 15 },
        { key: 'priceWithDPH', width: 15 },
        { key: 'priceTotal', width: 15 }
      ]
      this.invoices.forEach((item, index) => {
        if (item.transaction.user.company_name === null) item.transaction.user.company_name = ''
        sheet.getRow(5 + index).values = {
          id: item.id,
          transaction_id: item.transaction_id,
          created_at: new Date(item.created_at).toLocaleDateString('cs-CZ'),
          user: item.transaction.user.first_name + ' ' + item.transaction.user.last_name + '(' + item.transaction.user.company_name + ')',
          priceWithoutDPH: Math.round((item.transaction.price / 1.15) * 100) / 100,
          priceWithDPH: item.transaction.price - Math.round((item.transaction.price / 1.15) * 100) / 100,
          priceTotal: item.transaction.price
        }
      })
      workbook.xlsx.writeBuffer().then(data => {
        const blob = new Blob([data],
          { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
        const url = window.URL.createObjectURL(blob)
        const anchor = document.createElement('a')
        anchor.href = url
        anchor.download = 'export_faktury.xlsx'
        anchor.click()
        window.URL.revokeObjectURL(url)
      })
    }
  }
}
</script>

<style scoped>

</style>
